module.exports = __webpack_public_path__ + "img/stx.3c345d89.svg";